import { pdf } from "@react-pdf/renderer";
export const exportPdf = (params: {
    documentComponent: JSX.Element,
    fileName: string
}) => {
    pdf(params.documentComponent)
        .toBlob()
        .then((blob) => {
            const url = URL.createObjectURL(blob); 
            const link = document.createElement("a");
            link.href = url;
            link.download = params.fileName;
            link.click();
            URL.revokeObjectURL(url); 
        })
        .catch((error) => {
            console.error("Gagal membuat PDF:", error); 
        });
}